import React, { useEffect, useState } from "react";

import "./Manage.scss";
import NavLinkDelay from "@components/NavLinkDelay/NavLinkDelay";

import ManageRoute from "@route/ManageRoute";
import { useWidth } from "@utils/demenstion";
import { windowLocationOrigin } from "@utils/validation";
import { useHistory } from "react-router-dom";

const Manage = () => {
  const [animOnboard, setAnimOnboard] = useState(true);
  const [buttonSelect, setButtonSelect] = useState(0);
  let history = useHistory();
  const locationPath = location.pathname.split("/")[3];

  const handleNavOnClick = () => {
    setAnimOnboard(false);
  };

  // Handler
  const handleNavOnEnd = () => {
    setAnimOnboard(true);
  };

  useEffect(() => {
    console.log(locationPath);
    if (locationPath === "child") {
      setButtonSelect(1);
      return;
    }
    if (locationPath === "credit-card") {
      setButtonSelect(2);
      return;
    }
    setButtonSelect(0);
  }, [location.pathname]);

  const onPressPolicy = (url: string) => {
    window.open(`${windowLocationOrigin()}/${url}`, "_blank");
  };

  return (
    <div className="WrapperManage flex flex-col justify-between">
      <div className="Manage">
        <p className="header--30 color--white">Manage</p>
        <section className="md:w-4/6 w-full mt-16">
          <div className="overflow-x-autoscrollbarHide flex flex-row space-x-10 mb-10 border-solid border-b border-bahama_blue_hover">
            <h1
              onClick={() => {
                history.push("/dashboard/manage/profile");
                setButtonSelect(0);
              }}
              className={`text-3xl font-bold  cursor-pointer pb-6 ${
                buttonSelect === 0
                  ? "text-bahama_blue_hover border-solid border-b-4 border-bahama_blue_hover"
                  : "text-white"
              }`}
            >
              My Profile
            </h1>
            <h1
              onClick={() => {
                history.push("/dashboard/manage/child");
                setButtonSelect(1);
              }}
              className={`text-3xl font-bold  cursor-pointer pb-6  ${
                buttonSelect === 1
                  ? "text-bahama_blue_hover border-solid border-b-4 border-bahama_blue_hover"
                  : "text-white"
              }`}
            >
              Manage Child
            </h1>
            <h1
              // Disable temporary
              onClick={() => {
                history.push("/dashboard/manage/credit-card");
                setButtonSelect(2);
              }}
              className={`text-3xl font-bold  cursor-pointer pb-6  ${
                buttonSelect === 2
                  ? "text-bahama_blue_hover border-solid border-b-4 border-bahama_blue_hover"
                  : "text-white"
              }`}
            >
              Credit Card
            </h1>
          </div>
          <section className="">
            <div
              className={
                animOnboard ? "Manage__anim--onboard" : "Manage__anim--exit"
              }
            >
              <ManageRoute />
            </div>
          </section>
        </section>
      </div>
      {/* Foother */}
      <div className="bg-white p-5 mt-auto flex flex-row space-x-10">
        <span
          onClick={() => onPressPolicy("privacy-policy")}
          className={`Dashboard__linkText`}
        >
          Privacy Policy
        </span>
        <span
          onClick={() => onPressPolicy("term-and-conditions")}
          className={`Dashboard__linkText`}
        >
          Term & Conditions
        </span>
        <span
          onClick={() => onPressPolicy("waiver-and-indemnity")}
          className={`Dashboard__linkText`}
        >
          Waiver & Indemnity
        </span>
      </div>
    </div>
  );
};

export default Manage;

{
  /* <section className="col-md-3 Manage__listMenu">
              <NavLinkDelay
                to="/dashboard/manage/profile"
                onClick={() => {
                  handleNavOnClick();
                  setButtonSelect(0);
                }}
                onEnd={() => {
                  handleNavOnEnd();
                }}
                delay={200}
                activeClassName="activeItem"
                className={`Manage__pageLinkItem header--18`}
              >
                My profile
              </NavLinkDelay>

              <NavLinkDelay
                to="/dashboard/manage/child"
                onClick={() => {
                  handleNavOnClick();
                  setButtonSelect(1);
                }}
                onEnd={() => {
                  handleNavOnEnd();
                }}
                delay={200}
                activeClassName="activeItem"
                className={`Manage__pageLinkItem header--18 ${
                  buttonSelect === 1 ? "active" : ""
                }`}
              >
                Manage child
              </NavLinkDelay>

              <NavLinkDelay
                to="/dashboard/manage/credit-card"
                onClick={() => {
                  handleNavOnClick();
                  setButtonSelect(2);
                }}
                onEnd={() => {
                  handleNavOnEnd();
                }}
                delay={200}
                activeClassName="activeItem"
                className={`Manage__pageLinkItem header--18 ${
                  buttonSelect === 1 ? "active" : ""
                }`}
              >
                Manage Credit Card
              </NavLinkDelay>
            </section> */
}
